import { Component, Input } from '@angular/core';

@Component({
  selector: 'bs-report-icon',
  imports: [],
  template: `
  <svg id="report-icon" [style.width.px]="width" [style.height.px]="height" [style.fill]="iconFill" [style.stroke]="iconFill" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 72 72">
    <path d="M68.4,68.4H7.2c-1.988,0-3.6-1.612-3.6-3.6V3.6" style="fill: none; stroke-linecap: round; stroke-miterlimit: 10; stroke-width: 5px;"/>
    <line x1="14.4" y1="36" x2="14.4" y2="57.6" style="fill: none; stroke-linecap: round; stroke-miterlimit: 10; stroke-width: 4px;"/>
    <line x1="25.2" y1="21.6" x2="25.2" y2="57.6" style="fill: none; stroke-linecap: round; stroke-miterlimit: 10; stroke-width: 4px;"/>
    <line x1="36" y1="7.2" x2="36" y2="57.6" style="fill: none; stroke-linecap: round; stroke-miterlimit: 10; stroke-width: 4px;"/>
    <line x1="46.8" y1="28.8" x2="46.8" y2="57.6" style="fill: none; stroke-linecap: round; stroke-miterlimit: 10; stroke-width: 4px;"/>
    <line x1="57.6" y1="6.498" x2="57.6" y2="56.898" style="fill: none; stroke-linecap: round; stroke-miterlimit: 10; stroke-width: 4px;"/>
  </svg>
  `,
  styles: `
    .icon-fill {
      fill: var(--p-bs-icon-color);
    }`,
  standalone: true
})
export class BsReportIconComponent {
  @Input() width: number = 30;
  @Input() height: number = 30;
  @Input() iconFill: string = 'var(--p-bs-icon-color)';
}
